export default {
  TRIGGER_NEW_SEARCH: 'TRIGGER_NEW_SEARCH',
  TRIGGER_MORE_SEARCH: 'TRIGGER_MORE_SEARCH'
}
